import script from "./edu-switch-tip.vue?vue&type=script&setup=true&lang=js"
export * from "./edu-switch-tip.vue?vue&type=script&setup=true&lang=js"

import "./edu-switch-tip.vue?vue&type=style&index=0&id=0e08a915&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e08a915"]])

export default __exports__